import { createAsyncThunk } from "@reduxjs/toolkit";
import { _getBlob, _postFile } from "../Services/baseApi";
import { errorHandler, successToast } from "./toast";
import {
  downloadBlobFile,
  getFilenameFromDisposition,
} from "./downloadFile";

export const createMasterImportThunks = ({
  exportType,
  exportUrl,
  importUrl,
  sampleUrl,
  defaultExportFilename,
  defaultSampleFilename,
  exportSuccessMessage,
}) => {
  const exportThunk = createAsyncThunk(
    `${exportType}/exportThunk`,
    async (payload, { rejectWithValue }) => {
      try {
        const response = await _getBlob(exportUrl, payload?.params || {});
        const filename = getFilenameFromDisposition(
          response.headers["content-disposition"],
          defaultExportFilename
        );
        downloadBlobFile(response.data, filename);
        successToast(exportSuccessMessage);
        return true;
      } catch (error) {
        errorHandler(error);
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  );

  const downloadSampleThunk = createAsyncThunk(
    `${exportType}/downloadSampleThunk`,
    async (_, { rejectWithValue }) => {
      try {
        const response = await _getBlob(sampleUrl);
        const filename = getFilenameFromDisposition(
          response.headers["content-disposition"],
          defaultSampleFilename
        );
        downloadBlobFile(response.data, filename);
        return true;
      } catch (error) {
        errorHandler(error);
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  );

  const importThunk = createAsyncThunk(
    `${exportType}/importThunk`,
    async (payload, { rejectWithValue }) => {
      try {
        const formData = new FormData();
        formData.append("file", payload.file);
        const response = await _postFile(importUrl, formData);
        if (response?.data) {
          const result = response.data?.result;
          if (result?.imported > 0) {
            successToast(
              response.data.message || "Records imported successfully"
            );
            payload?.handleFun?.(result);
          } else {
            errorHandler({
              response: {
                data: {
                  message:
                    response.data.message ||
                    "No records were imported. Please check the file and try again.",
                },
              },
            });
          }
          return response.data;
        }
      } catch (error) {
        errorHandler(error);
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  );

  return { exportThunk, downloadSampleThunk, importThunk };
};
